import { render, staticRenderFns } from "./mhao_chaina_order.vue?vue&type=template&id=497b3734&scoped=true"
import script from "./mhao_chaina_order.vue?vue&type=script&lang=js"
export * from "./mhao_chaina_order.vue?vue&type=script&lang=js"
import style0 from "./mhao_chaina_order.vue?vue&type=style&index=0&id=497b3734&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497b3734",
  null
  
)

export default component.exports